import { userManager } from "../authService";
import { CallbackComponent } from "redux-oidc-2";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";

export default function Callback() {
  let navigate = useNavigate();
  let auth = useAppSelector((state) => state.auth);

  // complete auth
  const successCallback = () => {
    localStorage.setItem("authToken", auth.user.access_token);
    navigate("/");
  };

  const errorCallback = (error: Error) => {
    console.error(error);
    navigate("/");
  };

  return (
    <CallbackComponent
      successCallback={successCallback}
      errorCallback={errorCallback}
      userManager={userManager}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
}
